import React, {Component, PropTypes} from 'react'
import {Row, Col} from 'react-bootstrap'
import ProviderCoverageDashboard from './ProviderCoverageDashboard'
import ProviderCoverageStats from './ProviderCoverageStats'

class ProviderCoverageDashboardLayout extends Component {
    static propTypes = {
    }

    render() {
        return (
            <div>
                <Row>
                    <Col sm={4} smOffset={8}>
                        <ProviderCoverageStats />
                    </Col>
                </Row>
                <ProviderCoverageDashboard />
            </div>
        )
    }
}

export default ProviderCoverageDashboardLayout


// WEBPACK FOOTER //
// ./lib/provider/components/ProviderCoverageDashboardLayout.js